export const CustomPaginationSizes = {
  pageSize: 15,
  pageIndex: 0
};

export const DateFieldsFixedColumnSize = {
  sizeForDate: 120,
  sizeForDateAndTime: 120,
}

export const isDefaultCardView = true;
export const clickableColor = 'rgba(0, 94, 230, 1)';
export const clickableHexaColor = '#005EE6';
export const cementGrayColor = '#94a3b8';
export const clickableColorOutline = clickableColor;
export const iconColor = '#b2b2b2'
// export const iconsAndTextColor = 'rgb(165 167 171)';

// export const iconsAndTextColor ='#5d5d5d'
export const iconsAndTextColor = undefined
export const bgMaincolor = "light-dark(#f8fafc, var(--mantine-color-dark-6))";
export const bgNavMenu = "light-dark(rgb(255 255 255), var(--mantine-color-dark-6))";
export const navBarTextColor = 'rgb(203 213 225)';
export const sideNavbarMaincolor = '#1e293b'
// export const sideNavbarcolor = `linear-gradient(180deg, #0f172a, ${sideNavbarMaincolor})`;
export const sideNavbarcolor = "linear-gradient(to bottom, #0f172a 0%, #1e293b 100%)"
export const disableColor = "#adb5bd";

export const cardRadius = 'xl'
// export const sideNavbarBase = '#0f172a';
// export const sideNavbarGradientTo = '#1e293b';
export const cardHighlightColor = 'rgb(240 247 255)';
export const ThirdLevelHeadingfz= 16;
export const defaultEndDate = '12/31/9999'
export const ptoHoursColor = 'rgb(217 119 6)'
export const publichHolidaysHoursColor = 'rgb(124 58 237)';
export const colorDanger = 'var(--mantine-color-error)'
